import React, { FC, useCallback, useState } from 'react';
import classnames from 'classnames';

import { PopupGroup } from '@/scenarios/legacy-player/components/PlayerSkin/parts/PopupGroup';

import { BaseControlName } from '../../../feature-player/types/controls';
import { VolumeControl } from '../../../feature-player/ui/skin/volume-control/component';
import { SettingPopupButton } from '../../../feature-player/ui/skin/setting-popup-button/component';
import { FullScreenToggle } from '../../../feature-player/ui/skin/full-screen-toggle/component';
import { PlayerContentType } from '../../../feature-player/types/content';
import { useChangeSubtitlesPositionCallback } from '../../../feature-player/hooks/skin/use-change-subtitles-position-callback';
import { LiveOnAirControl } from '../../../feature-player/ui/live/live-on-air-control/container';
import { SportAudioSettingPopupButtonContainer } from '../SportAudioSettingPopupButtonContainer/SportAudioSettingPopupButtonContainer';

import styles from './SportPlayerControlPanel.module.css';

interface SportPlayerControlPanelProps {
    contentId: string;
    psid: string;
    className?: string;
    setIsHidingControlsBlocked: (isHidingControlsBlocked: boolean) => void;
    onEnlargementChanged?: (isEnlarged: boolean) => void;
}

export const SportPlayerControlPanel: FC<SportPlayerControlPanelProps> = ({
    contentId,
    className,
    setIsHidingControlsBlocked,
    onEnlargementChanged,
}) => {
    const [isSubtitleSizeSettingsForceOpened, setIsSubtitleSizeSettingsForceOpened] =
        useState(false);

    const changeSubtitlePosition = useChangeSubtitlesPositionCallback();
    const onPopupToggle = useCallback(
        (isPopupOpened: boolean) => {
            setIsHidingControlsBlocked(isPopupOpened);
            changeSubtitlePosition(isPopupOpened);
        },
        [setIsHidingControlsBlocked, changeSubtitlePosition]
    );

    return (
        <div className={classnames(styles.root, className)}>
            <div className={styles.controls}>
                <PopupGroup onPopupToggle={onPopupToggle}>
                    <div className={styles.leftControls}>
                        <LiveOnAirControl />
                        <VolumeControl onEnlargementChanged={onEnlargementChanged} />
                    </div>
                    <div className={styles.rightControls}>
                        <SportAudioSettingPopupButtonContainer
                            contentId={contentId}
                            name={BaseControlName.AUDIO_SUBS_LIST}
                            onSubtitleSizeSettingsClick={() =>
                                setIsSubtitleSizeSettingsForceOpened(true)
                            }
                        />
                        <SettingPopupButton
                            name={BaseControlName.ADJUSTMENT}
                            contentId={contentId}
                            contentType={PlayerContentType.CHANNEL}
                            isSubtitleSizeSettingsForceOpened={isSubtitleSizeSettingsForceOpened}
                            setIsSubtitleSizeSettingsForceOpened={
                                setIsSubtitleSizeSettingsForceOpened
                            }
                        />
                        <FullScreenToggle name={BaseControlName.FULLSCREEN} contentId={contentId} />
                    </div>
                </PopupGroup>
            </div>
        </div>
    );
};
